import React, { useState,Component } from 'react';
import Slider from "react-slick";
import capacityDataEN from '../data/en/capacity.json';
import capacityDataTH from '../data/th/capacity.json';
import capacityDataVN from '../data/vn/capacity.json';
import capacityDataAR from '../data/ar/capacity.json';
let cachecapacity:any= 0;
let capacityData:any={}
export default function ContainerItem(props:any){
    if(sessionStorage.getItem("capacity")){
      cachecapacity =  sessionStorage.getItem("capacity")
    }
    if(sessionStorage.getItem("lang")==="th"){
      capacityData = capacityDataTH
    }else if(sessionStorage.getItem("lang")==="vn"){
      capacityData = capacityDataVN
    }else if(sessionStorage.getItem("lang")==="ar"){
      capacityData = capacityDataAR
    }else{
      capacityData = capacityDataEN
    }
    const [module, setModule] = useState(parseInt(cachecapacity));
    const [capacityLists, setCapacityLists] = useState(capacityData);
    const onSelectRadio=(e:any)=>{
      const {value,name} = e.target 
      console.log(value)
      if(e.target.checked){
        setModule(parseInt(value))
        props.onUpdateCapacity(parseInt(value))
        
      }
    }
    const onSelectRadioItem=(id:any)=>{
      setModule(parseInt(id))
      props.onUpdateCapacity(parseInt(id))
    }
    const settings:any = {
      arrows:false,
      dots: true,   
      slidesToShow:2,
      slidesToScroll: 1,
      className: "center",
      centerPadding: "60px",
      centerMode: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            centerPadding: "20px",
          }
        },
        {
          breakpoint: 840,
          settings: {
            slidesToShow: 2,
            slidesToScroll:1,
            initialSlide: 1,
            infinite: true,
            dots: true,
            centerPadding: "0px",
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll:1,
            initialSlide: 1,
            centerPadding: "20px",
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: "32px",
            centerMode: true,
            infinite: false
          }
        }
      ]
    };
    return (
      <div className=" mt-5 mb-2">
      <Slider {...settings}>
        {
          capacityLists.map((item:any,key:number)=>  
          
          <div className="" key={`capacity${key}`} onClick={()=>onSelectRadioItem(item.id)}>
          <div className={`container-item capacity-item m-auto ${(module===item.id)?"bg-red":""}`}>
            <div className="images">
                <img src={`images/${(item.id===2)?"leftright.png":"arrowIn.png"}`} className="slideimg" alt=""/>
                <img src={item.image} alt={item.name}/>
            </div>
            <div className={`title-block  ${(module===item.id)?"bg-red":""}`} >
              <div className="m-auto display-inline-block">
                <input type="radio" className="radio-btn" name="choice" id={`a-opt${item.id}`} value={item.id} checked={(module===item.id)?true:false} onChange={onSelectRadio}/>
                {
                  (item.id===1)?
                  <>
                 <label htmlFor={`a-opt${item.id}`} className="radio"> {item.name} <span className="ms-2"> 570 </span></label>
                </>
                :
                <label htmlFor={`a-opt${item.id}`} className="radio">{item.name} </label>
                }
              </div>
            </div>
          </div>
        </div>
       
          )
        }
      </Slider>
      </div>
    );
  }
